import { get, post, patch, del } from '../utils/http';
import { publicRequest } from '../utils/api';
import { documentRequestDataTransformer } from './transformers/documents';
import { storeReferralSuggested } from '../utils/referral';

export const fetchDocument = (documentId) =>
  get(`documents/${documentId}`)
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

export const fetchSurveyorDocumentSignUrl = (revisionId) =>
  get(`documents/surveyordocument/signurl?revisionId=${revisionId}`).then(
    (response) => [response.data.success, response.data.response.url]
  );

export const fetchDocumentsToSignedStatus = (id) =>
  get(`documents/surveyordocuments/${id}/status`)
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

export const fetchDocumentsToSigned = () =>
  get(`propertyOwners/documentstosigned`)
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

export const updateDocument = (documentId, data) =>
  patch(`documents/${documentId}`, data, {
    transformRequest: documentRequestDataTransformer,
  })
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

export const createDocument = (data) =>
  post('documents', data, { transformRequest: documentRequestDataTransformer })
    .then((response) => {
      storeReferralSuggested(false);
      return [null, response.data.response];
    })
    .catch((error) => [error, null]);

export const createFolder = (data, boligmappaNumber) =>
  post(`/properties/${boligmappaNumber}/directories`, data)
    .then((response) => {
      return [null, response.data.response];
    })
    .catch((error) => [error.response.data, null]);

export const createPersonalFolder = (data) =>
  post('propertyowners/directories', data)
    .then((response) => {
      return [null, response.data.response];
    })
    .catch((error) => [error.response.data, null]);

export const createPersonalFolderStructure = (data) =>
  post('propertyowners/directory-structures', data)
    .then((response) => {
      return [null, response.data.response];
    })
    .catch((error) => [error.response.data, null]);

export const createFolderStructure = (data, boligmappaNumber) =>
  post(`/properties/${boligmappaNumber}/directory-structures`, data)
    .then((response) => {
      return [null, response.data.response];
    })
    .catch((error) => [error.response.data, null]);

export const deleteDocument = (documentId) =>
  del(`documents/${documentId}`)
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

export const deletePropertyDocumentFolder = (folderId, boligmappaNumber) =>
  del(`properties/${boligmappaNumber}/directories/${folderId}`)
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

export const updatePropertyDocumentDirectory = (data, id, boligmappaNumber) =>
  patch(`properties/${boligmappaNumber}/directories/${id}`, data)
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

// Public APIs
export const getPublicDocuments = (boligmappaNumber, params) =>
  publicRequest
    .get(`/properties/${boligmappaNumber}/documents`, { params })
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);

// eslint-disable-next-line arrow-body-style
export const fetchPublicDocument = (documentId) => {
  return publicRequest
    .get(`/documents/${documentId}`)
    .then((response) => [null, response.data.response])
    .catch((error) => [error, null]);
};
